/* lax-guide.js — hydrates product cards and sizes Instagram embeds in gear guide posts. */
(function () {
  'use strict';
  var root = document.querySelector('.lax-guide');
  if (!root) return;

  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var money = function (c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: currency }); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var sized = function (src, w) {
    if (!src) return '';
    if (/^data:/.test(src)) return src;
    try { var u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  };
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(shopRoot + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return cache[handle];
  }

  function priceHtml(p) {
    var sale = p.compare_at_price_min && p.compare_at_price_min > p.price_min;
    var h = '<span class="lax-card__price' + (sale ? ' is-sale' : '') + '">' + (p.price_varies ? 'From ' : '') + money(p.price_min) + '</span>';
    if (sale) h += '<span class="lax-card__compare">' + money(p.compare_at_price_min) + '</span>';
    return h;
  }
  function optionsText(p) {
    var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? null : o; }).filter(Boolean);
    var color = opts.find(function (o) { return /colou?r/i.test(o.name); });
    if (color && color.values && color.values.length > 1) return color.values.length + ' colors';
    var other = opts.find(function (o) { return o.values && o.values.length > 1 && !/title/i.test(o.name); });
    return other ? other.values.length + ' ' + other.name.toLowerCase() + ' options' : '';
  }

  function renderCard(el, p) {
    var url = p.url || el.dataset.url;
    var img = p.featured_image || (p.images && p.images[0]);
    var sale = p.compare_at_price_min && p.compare_at_price_min > p.price_min;
    var opts = optionsText(p);
    var action = '<a class="lg-btn" href="' + url + '">View product</a>';

    el.innerHTML =
      '<a class="lax-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + sized(img, 600) + '" srcset="' + sized(img, 400) + ' 400w, ' + sized(img, 800) + ' 800w" sizes="(min-width:860px) 340px, 90vw" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
        (sale ? '<span class="lax-card__badge">Sale</span>' : '') +
      '</a>' +
      '<div class="lax-card__body">' +
        (p.vendor ? '<p class="lax-card__vendor">' + esc(p.vendor) + '</p>' : '') +
        '<a class="lax-card__title" href="' + url + '">' + esc(p.title) + '</a>' +
        '<div class="lax-card__meta">' + priceHtml(p) + '</div>' +
        (opts ? '<p class="lax-card__opts">' + esc(opts) + '</p>' : '') +
        '<p class="lax-card__stock' + (p.available ? '' : ' is-out') + '">' + (p.available ? 'In stock' : 'Sold out') + '</p>' +
        '<div class="lax-card__actions">' + action + '</div>' +
      '</div>';
    el.classList.remove('is-loading');
    el.classList.add('is-ready');

    // Fill the matching comparison-table row with thumbnail + price
    root.querySelectorAll('[data-row-handle="' + el.dataset.handle + '"]').forEach(function (row) {
      var a = row.querySelector('td:first-child a');
      if (a && img && !a.querySelector('img')) a.insertAdjacentHTML('afterbegin', '<img class="lg-table__thumb" src="' + sized(img, 100) + '" alt="" loading="lazy" width="44" height="44">');
      var pc = row.querySelector('[data-price]');
      if (pc) pc.innerHTML = (p.price_varies ? 'From ' : '') + money(p.price_min);
    });
  }

  root.querySelectorAll('.lax-card[data-handle]').forEach(function (el) {
    el.classList.add('is-loading');
    getProduct(el.dataset.handle).then(function (p) { renderCard(el, p); })
      .catch(function () { el.classList.remove('is-loading'); }); // fallback markup stays
  });

  // Instagram iframes report their content height via postMessage
  window.addEventListener('message', function (e) {
    if (!/(^|\.)instagram\.com$/.test((function () { try { return new URL(e.origin).hostname; } catch (x) { return ''; } })())) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
    if (!d || d.type !== 'MEASURE' || !d.details || !d.details.height) return;
    root.querySelectorAll('.lg-video iframe').forEach(function (f) {
      if (f.contentWindow === e.source) f.style.height = Math.ceil(d.details.height) + 'px';
    });
  });
})();
